import React, { useMemo } from 'react';

import { renderWhenTrue } from '../../../utils/rendering';
import {
  Wrapper,
  Container,
  TitlesWrapper,
  Title,
  Subtitle,
  ChildrenWrapper,
  ShareButton,
  TitleAndShareWrapper,
} from './header.styles';
import { useShareModal } from '../../../hooks/useShareModal';
import ShareModal from '../../shareModal/shareModal.component';
import { useChartContext } from '../../../store/ChartContext';
import { useWindowLocation } from '../../../hooks/useWindowLocation';
import { formatURLToGetChartShareLink } from './header.helpers';
import { useIntl } from 'gatsby-plugin-intl';

export const renderTitles = ({ title, subtitle, xOffset, config }) =>
  renderWhenTrue(() => (
    <TitlesWrapper xOffset={xOffset}>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </TitlesWrapper>
  ))(config.titlesVisibility);

export const Header = ({ title, subtitle, tabs, xOffset = 0, config, children }) => {
  const shareModalState = useShareModal();
  const chartContext = useChartContext();
  const getWindowLocation = useWindowLocation();
  const location = getWindowLocation() || {};
  const linkToChart = useMemo(() => formatURLToGetChartShareLink(location, chartContext.chart.id), [
    location,
    chartContext.chart.id,
  ]);
  const { formatMessage } = useIntl();

  if (title) title = formatMessage({ id: title });
  if (subtitle) subtitle = formatMessage({ id: subtitle });

  return renderWhenTrue(() => (
    <>
      <Wrapper>
        <Container>
          <TitleAndShareWrapper>
            {renderTitles({ title, subtitle, xOffset, config })}
            {chartContext.canShare && <ShareButton onClick={shareModalState.onRequestOpen} />}
          </TitleAndShareWrapper>
          <ChildrenWrapper>{children}</ChildrenWrapper>
        </Container>
        {tabs}
      </Wrapper>
      {shareModalState.isOpen && <ShareModal modalProps={shareModalState} linkToShare={linkToChart} />}
    </>
  ))(config.titlesVisibility || !!children || !!tabs);
};
